export const PaymentMixin = {
  data() {
    return {
      labels: {
        payment: 'Payment Information',
        paytMode: 'Payment Mode*',
        paytCCNo: 'Credit Card No.*',
        paytCCName: 'Name on Card*',
        paytExpDate: 'Expiry Date*',
        paytCCCvv: 'CCV/CVC*',
        paytInstalmentPlan: 'Instalment Plan*'
      },
      // Unmask/temp variables
      paytCCNo: undefined,
      paytExpDate: undefined,
      tempCCType: undefined
    }
  },
  computed: {
    ccIcon() {
      if (this.tempCCType) {
        if (this.tempCCType === 'visa') {
          return 'fab fa-cc-visa'
        } else if (this.tempCCType === 'mastercard') {
          return 'fab fa-cc-mastercard'
        } else if (this.tempCCType === 'diners') {
          return 'fab fa-cc-diners-club'
        } else if (this.tempCCType === 'amex') {
          return 'fab fa-cc-amex'
        } else if (this.tempCCType === 'jcb') {
          return 'fab fa-cc-jcb'
        } else if (this.tempCCType === 'discover') {
          return 'fab fa-cc-discover'
        } else {
          return 'mdi-credit-card'
        }
      } else {
        return 'mdi-credit-card'
      }
    }
  },
  watch: {
    'paytCCNo': {
      handler: function (value) {
        if (this.$refs.paytCCNo && this.$refs.paytCCNo.$el.cleave) {
          this.tempCCType = this.$refs.paytCCNo.$el.cleave.properties.creditCardType
        }
      }
    }
  },
  methods: {
    formatExpDate(mth, yr) {
      if (mth && yr) {
        if (mth < 10) {
          mth = '0' + mth
        }
        this.paytExpDate = mth + '-' + yr
      }
    },
    backEndCCTypeFormat() {
      if (this.tempCCType) {
        if (this.tempCCType === 'visa') {
          return 'VIS'
        } else if (this.tempCCType === 'mastercard') {
          return 'MAS'
        } else if (this.tempCCType === 'amex') {
          return 'AMEX'
        } else {
          return 'OTH'
        }
      } else {
        return 'OTH'
      }
    }
  }
}
